import React from 'react';
import './App.css';
import QuizEngine from './components/QuizEngine';
import QuizSetup, { ISetup } from './components/QuizSetup';

function App() {
  const [setup,setSetup] = React.useState({} as ISetup);
  const [isSetup,setIsSetup] = React.useState(false);
  
  const onSetupFinished = (setup: ISetup) => {
      setSetup(setup);
      setIsSetup(true);
  };

  return (
    <div className="App">
      {isSetup ? 
        <QuizEngine book={setup.book} chapters={setup.chapters} length={setup.length} mode={setup.mode} />
      :
        <QuizSetup onContinue={onSetupFinished}/>
      }
    </div>
  );
}

export default App;
